







import Component, { mixins } from 'vue-class-component';
import { namespace } from 'vuex-class';
import TooltipAble from '../../mixins/tooltip';
import { SubBrand } from '@/store/modules/themes';
import { Modules } from '@/store/store';

const themeModule = namespace(Modules.themes);

@Component({ name: 'eqweb-sub-headline' })
export default class SubHeadline extends mixins(TooltipAble) {
  @themeModule.Getter('subBrand')
  private readonly subBrand!: SubBrand;
}
